import { Injectable } from '@angular/core';
import { SessionStorageKeys } from '../core/enums/SessionStorageKeys';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  /**
   * Guardar un valor en sessionStorage con una clave específica.
   */
  set<T>(key: SessionStorageKeys, value: T, notStringify?: boolean): void {
    try {
      if (typeof value === 'undefined') {
        console.error(
          `SessionStorageService: Trying to set undefined value for key "${key}"`
        );
        return;
      }
      const serializedValue = notStringify ? value as string : JSON.stringify(value);
      sessionStorage.setItem(key, serializedValue);
    } catch (error) {
      console.error(`SessionStorageService: Failed to set key "${key}"`, error);
    }
  }
  get<T>(key: SessionStorageKeys): T | null {
    const item = sessionStorage.getItem(key);
    if (!item) {
      return null;
    }
    try {
      // Intenta parsear el valor
      return JSON.parse(item) as T;
    } catch (error) {
      // Si falla el parseo, asumimos que es una cadena ya
      return item as unknown as T;
    }
  }
  /**
   * Eliminar un valor desde sessionStorage.
   */
  remove(key: SessionStorageKeys): void {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error(
        `SessionStorageService: Failed to remove key "${key}"`,
        error
      );
    }
  }

  removeArray(keys: SessionStorageKeys[]): void {
    try {
      keys.forEach((key: SessionStorageKeys) => {
        sessionStorage.removeItem(key);
      })
    } catch (error) {
      console.error(
        `SessionStorageService: Failed to remove keys`,
        error
      );
    }
  }
  /**
   * Limpiar todos los valores de sessionStorage.
   */
  clear(): void {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error('SessionStorageService: Failed to clear storage', error);
    }
  }
  /**
   * Verifica si existe una clave en sessionStorage.
   */
  exists(key: SessionStorageKeys): boolean {
    return sessionStorage.getItem(key) !== null;
  }
}